/**
 * Dynamic .-is-empty class for form field style
 */
export default () => {
  const inputTagTypes = [
    'text',
    'email',
    'number',
    'password',
    'search',
    'tel'
  ];

  function checkAllInputs() {
    document.querySelectorAll('input, select, textarea').forEach(function(element) {
      checkInput(element);
    });
  }

  function checkContextualInputs(event) {
    $(event.target).find('input, select, textarea').each(function() {
      checkInput(this);
    });
  }

  function checkInput(input) {
    let needsProcessing = false;

    // We only care about the elements corresponding to .aauw-form-field CSS
    if (input.tagName === 'SELECT' || input.tagName === 'TEXTAREA') {
      needsProcessing = true;
    } else if (input.tagName === 'INPUT' && inputTagTypes.includes(input.getAttribute('type'))) {
      needsProcessing = true;
    }

    // If it is not an appropriate form input type, or if it is not a child of a
    // .aauw-form-field element, bail now before doing anything
    if (!needsProcessing || !input.parentElement || !input.parentElement.classList.contains('aauw-form-field')) {
      return;
    }

    // Treat invalid number elements as filled to solve edge case where invalid values are not passed to browser
    if (input.value || (input.getAttribute('type') === 'number' && !input.checkValidity())) {
      // input.classList.add('-filled');
      input.classList.remove('-empty');
    } else {
      // input.classList.remove('-filled');
      input.classList.add('-empty');
    }
  }

  function inputChange(event) {
    checkInput(event.target);
  }

  document.addEventListener('input', inputChange);
  // Because Edge is buggy and does not fire input for <select> elements, we
  // need to listen for change as well.
  document.addEventListener('change', inputChange);

  // Listen for FacetWP loading content via AJAX
  $(document).on('facetwp-loaded', checkAllInputs);

  // Listen for other kinds of AJAX loading, which must be signalled manually
  $(document).on('aauw-dynamic-form-inserted', checkContextualInputs);

  // Check all items for initial state
  checkAllInputs();

  document.documentElement.classList.add('-aauw-form-fields-init');
};
